<template>
  <div class="search__sources-wrapper">
    <expandable v-if="Object.keys(this.sources).length > 0" class="search__sources">
      <template v-slot:title> {{ label }} </template>
      <template v-slot:content>
        <ul v-if="sources && sources.lenght !== 0" class="search__sources-list">
          <li
            v-for="(source, index) in sources"
            v-bind:key="index"
            :class="activeElements.includes(source.name) ? 'search__sources-item--active' : null"
            class="search__sources-item"
          >
            <button @click="handleClick(source.name)" class="search__source" type="button">
              <span class="search__source-tick tick"></span>
              <span class="search__source-title">{{ source.name }}</span>
              &nbsp;({{ source.count }})
            </button>
          </li>
        </ul>
      </template>
    </expandable>
  </div>
</template>

<script>
import expandable from "../components/expandable/expandable";

export default {
  name: "sources",
  components: {
    expandable,
  },
  props: {
    sources: {},
    queryParams: {},
    queryParamKey: {
      type: String,
    },
    label: {
      type: String,
    },
  },
  data() {
    return {
      activeElements: [],
    };
  },
  methods: {
    handleClick(sourceName) {
      const activeElements = [...this.activeElements];

      const isActive = activeElements.indexOf(sourceName);

      isActive > -1 ? activeElements.splice(isActive, 1) : activeElements.push(sourceName);

      this.setActiveElements(activeElements);
    },
    updateFilter() {
      const args = {
        sources: {
          value: this.activeElements.length > 0 ? this.activeElements : null,
          handler: this.filterHandler,
          queryParamKey: this.queryParamKey,
        },
      };

      this.$emit("updateFilter", args);
    },
    filterHandler(docs) {
      if (this.activeElements.length === 0) return docs;

      const filteredDocs = [];

      for (const doc of docs) {
        if (doc.source && this.activeElements.includes(doc.source)) {
          filteredDocs.push(doc);
        }
      }

      return filteredDocs;
    },
    setActiveElements(values) {
      this.activeElements = values;
      this.updateFilter();
    },
    setDefaultState() {
      let values = [];

      if (this.queryParamKey) {
        values = this.$getQueryParamValueByKey(this.queryParams, this.queryParamKey, true);

        if (!values || values.length == 0)
          values = [];
      }

      this.setActiveElements(values);
    },
  },
  mounted() {
    this.setDefaultState();
  },
};
</script>
